import { throttle } from './utils.js';

function initStickyHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;

    function onScroll() {
        if (window.scrollY > 0) {
            header.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
        }
    }

    window.addEventListener('scroll', throttle(100, onScroll));
    window.addEventListener('load', onScroll);
    onScroll();
}

document.addEventListener('DOMContentLoaded', initStickyHeader);
